module.exports = __webpack_public_path__ + "static/pullman-wallpaper-531e23bc6cc8681e556618126cc7bb2b.jpg";